export default "__VITE_ASSET__CoW$V8eX__"